import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Home from "./pages/Home";
import Pricing from "./pages/Pricing";
import ContactUs from "./pages/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Conditions from "./pages/Conditions";
import ConditionDetail from "./pages/ConditionDetail";
import ServiceDetail from "./pages/ServiceDetail";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/conditions" element={<Conditions />} />
            <Route path="/conditions/:slug" element={<ConditionDetail />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            {/* Common legacy/typo paths redirected to correct pages */}
            <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
            <Route path="/home" element={<Navigate to="/" replace />} />
            <Route path="/services" element={<Navigate to="/#services" replace />} />
            <Route path="/team" element={<Navigate to="/" replace />} />
            <Route path="/about" element={<Navigate to="/" replace />} />
            <Route path="/testimonials" element={<Navigate to="/" replace />} />
            <Route path="/book" element={<Navigate to="/contact" replace />} />
            <Route path="/booking" element={<Navigate to="/contact" replace />} />
            <Route path="/appointment" element={<Navigate to="/contact" replace />} />
            {/* Catch-all: any unknown route redirects to home (prevents blank pages) */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
          <Toaster position="top-right" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
